/**
 * beacon-i18n — shared i18n instance for all support Beacon widget Preact
 * components (see plan "Design"). Same pattern as chat-i18n.js / support-i18n.js.
 *
 * Usage:
 *   import { t } from '../beacon-i18n.js'
 *   t('support.beacon.home.ai_card.title')
 */

import { I18n } from 'i18n-js'
import locales from '../../locales.json'

const i18n = new I18n(locales)
i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'

export function t(key, opts) {
  return i18n.t(key, opts)
}
